import { StatusMessageProps } from './JobStatusMessage';
import { StatusMessage } from './JobStatusMessage';
import { SkeletonGrid } from './JobSkeletonGrid';

export const JobStatusWithSkeleton: React.FC<StatusMessageProps> = ({
  title,
  description,
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "32px",
      alignItems: "center",
    }}
  >
    <SkeletonGrid rows={2} columns={2} />
    <StatusMessage title={title} description={description} />
  </div>
);